import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const PUPPY_SILHOUETTE = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80.2 103.5"
    className="mw-100 max-h-100"
  >
    <path
      fill="currentColor"
      d="M80.11 79.1a27 27 0 0 0-1.27-10.46c-1.61-6.08-5.93-11.32-10.65-13.29-1.39-.59-3.14-1.42-5-2.39-2.81-1.46-5.9-3.22-8.51-4.92l-1.25-.84c-1-.7-1.91-1.37-2.65-2a10.54 10.54 0 0 1-1.68-1.68c-3.13-4.31-5.33-7.8-6.53-9.8-.73-1.21-1.09-1.88-1.09-1.88l.3-2c0-.41.12-.86.18-1.34.17-1.2.35-2.58.51-3.89.09-.78.17-1.54.24-2.22A16.08 16.08 0 0 0 41 13.5a10 10 0 0 0 2.8 2.18c4.59 2.21 8.62-.5 9.1-3S47.72 2.8 44.5 1.39C42.62.57 37 3.14 32.77 5.4a19.83 19.83 0 0 0-9.1-2.26 18.7 18.7 0 0 0-6.28 1.08l-.83.31-.22.1c-2.6-2.42-5.62-4.81-7-4.62C6.41.38.23 4.79 0 7s2.37 5.23 6.53 4.55a6.84 6.84 0 0 0 1.85-.62 15.34 15.34 0 0 0-2.32 4.13c-.12.29-.22.57-.32.86s-.2.58-.29.87c-.17.59-.32 1.19-.44 1.8a18.76 18.76 0 0 0-.37 3.77v1.88a2 2 0 0 0 0 .25v.24a.59.59 0 0 0 0 .13v.39a2.17 2.17 0 0 0 0 .25v.21c0 .23.09.47.13.69q.07.34.15.66v.19c0 .06.08.33.13.49l.06.2c0 .17.09.33.14.49l.06.17c.06.2.12.4.19.6.3.87.62 1.76 1 2.7 0 .12.08.24.13.36a6.34 6.34 0 0 0-.9 1.21c-3.68 6.38 2.56 9.42 7 9.53h2a.11.11 0 0 0 .07 0l.44.48a1.7 1.7 0 0 1 0 .22 1.94 1.94 0 0 1 0 .24 5.66 5.66 0 0 1-.17 1.38l-.06.21c-.14.48-.33 1-.53 1.52-.51 1.47-1.09 3.59-1.09 8.25v.78c0 .26 0 .52.05.78 0 1.69 2.41 18.19 3.47 26.34a33.43 33.43 0 0 1 .46 4.5c-2.88 0-5.84.94-6.62 3a2.9 2.9 0 0 0-.12.42 2.93 2.93 0 0 0 0 1.45c.51 1.73 3.06 2 5.55 2a17.26 17.26 0 0 0 4.79-1.42c1.26-.51 2.24-1 2.24-1s.22-.91.5-2.39c.15-.74.3-1.61.46-2.59 0-.24.07-.49.11-.74.11-.77.22-1.58.32-2.42s.22-1.83.37-2.95c.25-1.88.56-4.06.85-6.18l.75.38.17.08.76.35h.05l.77.31h.11c.27.11.55.21.83.3.59.19 1.19.35 1.8.49.45.1.91.18 1.38.25v.46c0 2.34 1.18 13.17 3 19.09-3.06 0-5.28 2.08-5.53 3.56-.62 3.73 2.56 3.19 5.66 3.19s5.88-1.19 6.22-3.19c.1-.63 1.25-6.68 2.39-12.79l.37.34.33.29.89.79.44.38c.21.19.36.32.43.37l.78.58c.25.18.52.36.78.53h.05c.26.17.52.33.79.48h.07l.78.42H50l.77.37.14.06.76.31.17.07.75.26.21.07.72.22.25.07.71.17H54.77l.69.13.31.06c.23 0 .47.06.7.09h.33c.24 0 .48 0 .73.06h.06c-.77.39-1.54.8-2.23 1.2a17.73 17.73 0 0 0-2.22 1.43c-.12.1-.23.19-.32.28a3.33 3.33 0 0 0-.46.59 5.76 5.76 0 0 0-.65 1.47c-.08.26-.15.53-.21.8a2.93 2.93 0 0 0 .46 2.32 2.74 2.74 0 0 0 .39.45l.11.08a3 3 0 0 0 .63.41 2.91 2.91 0 0 0 .89.29q.76.1 1.62.18a13.57 13.57 0 0 0 4.07-.18 5.86 5.86 0 0 0 .67-.21 20.08 20.08 0 0 0 4.28-2.68c2.38-1.01 3.78-2.34 3.78-2.34l3.08-2.27 2.27-1.67c2.55-1.89 4-3.5 5-6.1a16 16 0 0 0 1.36-8.43z"
    />
  </svg>
);

const DOG_SILHOUETTE = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 153.39 172.31"
    className="mw-100 max-h-100"
  >
    <path
      fill="currentColor"
      d="M152.7 88.83h-.46a40 40 0 0 1-38.52-19.75c-.13-.27-.27-.54-.41-.81-4.86-9-18.23-15.43-34-15.56h-.49c-1.67 0-3.32.08-4.94.22-16.77 0-22.6-7-24.11-9.4l3.77-10.43A14.12 14.12 0 0 0 54 25l.29.15c4.28 2.06 10.26 2.27 13 .58 1.94-1.19 1.24-3.77 1.56-5.47.79-4.19-8.25-15.69-13.38-18-2.5-1.09-9.13 1.55-15.15 4.54a14.06 14.06 0 0 0-4.67-.8h-7.84a14.37 14.37 0 0 0-3.54.45C21.93 3.12 19.53.33 17.83.08 13.18-.62 1.62 3.51.31 6.83S1.68 16 8.45 16.8a14.88 14.88 0 0 0 5.41-.65l-2.93 5.07a14.08 14.08 0 0 0-1 11.88l.3.81c-.94.66-3.25 7.22-.93 12.84 1.42 3.43 5 9 10.53 9.35.53 1.82.83 2.59.47 3.65-2 6-1.18 23.89 4 35 7 15 13 65 13 65a29.92 29.92 0 0 0-5 2c-2 1-4.85 3.44-4 6s3.36 3.62 7.52 3a41 41 0 0 0 11.48-3s-1-40-1.19-52.62c3.3.74 4.28 1.19 8.83.88.76 10.13 4.74 36.09 6.34 44.76 0 0-11 3-8 10 .91 2.12 6.94 1.68 11 1 6-1 7-5 7-5 0-29 1.6-39.91.51-54.25.53-.21 1.06-.43 1.59-.67.39 1.71 3.9 9.92 13.4 17.84 4 3.36 2.09 21.65 2.09 21.65l-3.59 1.76c-2.35 1.16-4.9 4.58-3 6.34 2.52 2.28 14.4 1.69 15-1.67 1-6 2-24 1.4-27.37-.69-3.82-3.83-10.44-4.4-14.63a27.71 27.71 0 0 1 2.15-12.3c.67 8.06.94 11.27 1.85 14.3 3 10 7 12 10 21 1 3 2.92 8.54 3 13 0 1.74 0 7-1.47 7.95-1.78 1.13-5.2 3.79-4.53 6.05.82 2.72 10.43 1.85 11.46.95l2.63-2.3a4.18 4.18 0 0 0 1.42-3.71c-.76-5.93-2.73-20.27-2.67-29.57a213.57 213.57 0 0 1 1.77-23.8A112.15 112.15 0 0 0 119.6 87a40 40 0 0 0 33.4 3 .62.62 0 0 0-.3-1.17z"
    />
  </svg>
);

const DOG_SILHOUETTE_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 72"
    className="mw-100 max-h-100"
  >
    <defs>
      <circle id="DOG_SILHOUETTE_ICON" cx="36" cy="36" r="36" />
    </defs>
    <mask id="DOG_SILHOUETTE_ICON--mask" fill="#fff">
      <use href="#DOG_SILHOUETTE_ICON" />
    </mask>
    <use fill="#E6E6EB" href="#DOG_SILHOUETTE_ICON" />
    <path
      fill="#040416"
      fillOpacity=".2"
      d="M16.151 41.116c.875.045 1.881-.489 2.644-1.538 1.423-1.957 2.445-5.35 3.669-8.804-.848 6.184-1.677 13.242-1.27 14.636.912 3.122 2.7 4.726 3.397 6.15.03.06.055.12.082.179.113.253.277.595.155 1.364a2.26 2.26 0 0 1-.052.227c-.778 3.05-5.991 9.728-7.74 12.146a100.274 100.274 0 0 0-2.11 3.02c-3.647 5.47-4.931 9.136-4.655 14.762l2.716 23.324 48.553-.61.193-22.714c.324-6.602-1.503-10.499-6.77-17.782-1.748-2.418-6.96-9.096-7.74-12.146-.02-.08-.04-.154-.051-.227-.121-.769.043-1.11.155-1.364.027-.059.053-.12.083-.18.696-1.423 2.483-3.027 3.397-6.15.406-1.393-.423-8.451-1.272-14.635 1.226 3.455 2.246 6.847 3.67 8.804.764 1.05 1.77 1.583 2.644 1.538.952.044 1.785-.566 2.042-1.91.961-5.032 5.33-9.71 3.78-14.554-1.219-3.807-3.06-4.127-5.673-4.618a33.233 33.233 0 0 1-2.381-.551c-2.552-.802-7.382-3.214-10.769-3.468-1.803-.134-5.5.664-6.847.68-1.35-.016-4.932-.707-7.01-.68-3.05.041-8.055 2.666-10.608 3.468-.804.214-1.604.405-2.381.551-2.613.491-4.454.811-5.672 4.618-1.55 4.843 2.818 9.522 3.78 14.554.256 1.344 1.088 1.954 2.041 1.91"
      mask="url(#DOG_SILHOUETTE_ICON--mask)"
    />
  </svg>
);

const PUPPY_SILHOUETTE_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    className="mw-100 max-h-100"
  >
    <defs>
      <circle id="PUPPY_SILHOUETTE_ICON" cx="20" cy="20" r="20" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PUPPY_SILHOUETTE_ICON--mask" fill="#fff">
        <use href="#PUPPY_SILHOUETTE_ICON" />
      </mask>
      <use fill="#E6E6EB" href="#PUPPY_SILHOUETTE_ICON" />
      <path
        fill="#040416"
        fillOpacity=".2"
        d="M13.752 18.569c-.39 2.854-.773 5.361-.586 6.005.421 1.44 1.247 2.18 1.568 2.838.014.028.026.056.038.083.052.117.128.275.072.63a1.043 1.043 0 0 1-.024.104c-.36 1.408-2.765 4.49-3.573 5.606a46.28 46.28 0 0 0-.973 1.394c-1.684 2.524-2.276 4.217-2.149 6.813L9.38 52.807l22.408-.281.09-10.484c.15-3.047-.694-4.845-3.124-8.207-.808-1.116-3.214-4.198-3.573-5.606-.01-.036-.018-.07-.024-.105-.056-.354.02-.512.072-.63l.038-.082c.321-.657 1.146-1.397 1.568-2.838.187-.644-.195-3.151-.587-6.005.566 1.594 1.253 2.181 2.914 2.523.44.02.824-.261.943-.882.443-2.322 2.46-2.981 1.744-5.217-.562-1.757-1.412-1.904-2.618-2.131a15.338 15.338 0 0 1-1.1-.255c-1.177-.37-3.406-1.483-4.97-1.6-.832-.062-2.538.306-3.16.313-.622-.007-2.276-.326-3.235-.313-1.408.019-3.718 1.23-4.896 1.6-.371.1-.74.187-1.099.255-1.206.227-2.056.374-2.618 2.131-.715 2.236 1.3 2.895 1.745 5.217.118.62.502.903.942.882.404.02 2.349-.929 2.913-2.523z"
        mask="url(#PUPPY_SILHOUETTE_ICON--mask)"
      />
    </g>
  </svg>
);

const PUPPY_ICON_RECT = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 48"
    className="mw-100 max-h-100"
  >
    <defs>
      <rect id="PUPPY_ICON_RECT" x="0" y="0" width="72" height="48" rx="3" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PUPPY_ICON_RECT--mask" fill="#fff">
        <use href="#PUPPY_ICON_RECT" />
      </mask>
      <use fill="#E6E6EB" href="#PUPPY_ICON_RECT" />
      <path
        fill="#040416"
        fillOpacity=".2"
        d="M27.15 22.862c-.555 4.096-1.097 7.695-.831 8.619.597 2.068 1.766 3.13 2.221 4.073.02.04.036.08.054.119.074.168.181.394.101.903-.007.049-.02.098-.034.15-.509 2.02-3.917 6.445-5.061 8.046a66.442 66.442 0 00-1.379 2c-2.385 3.623-3.224 6.052-3.044 9.778L20.953 72l31.746-.404.126-15.046c.212-4.372-.982-6.953-4.426-11.778-1.143-1.601-4.551-6.025-5.061-8.045-.013-.053-.026-.102-.033-.15-.08-.51.028-.736.101-.904l.054-.119c.455-.943 1.624-2.005 2.221-4.073.266-.924-.276-4.523-.83-8.619.8 2.289 1.774 3.13 4.127 3.621.623.03 1.167-.374 1.336-1.265.628-3.333 3.484-4.279 2.47-7.487-.796-2.522-2-2.734-3.708-3.059a21.492 21.492 0 01-1.557-.365c-1.669-.53-4.827-2.129-7.041-2.297-1.18-.089-3.597.44-4.477.45-.883-.01-3.225-.468-4.584-.45-1.994.027-5.267 1.766-6.936 2.297-.525.142-1.049.268-1.557.365-1.708.325-2.912.537-3.709 3.059-1.013 3.208 1.843 4.154 2.472 7.487.168.89.712 1.295 1.335 1.265.572.03 3.327-1.332 4.127-3.62z"
        mask="url(#PUPPY_ICON_RECT--mask)"
      />
    </g>
  </svg>
);

export default function DogPlaceholderSvg({
  puppy,
  icon,
  rect,
  className,
  minWidth,
  minHeight,
  width,
  height
}) {
  return (
    <div
      className={classnames(
        'DogPlaceholderSvg relative dib v-top f0 moon-gray tc',
        className
      )}
      style={{
        width,
        height,
        minWidth,
        minHeight
      }}
    >
      <div
        className={classnames('w-100 transform-center', {
          'h-60': puppy && !icon && !rect,
          'h-50': !puppy && !icon && !rect
        })}
      >
        {(() => {
          if (rect) {
            return PUPPY_ICON_RECT;
          }
          if (icon) {
            return puppy ? PUPPY_SILHOUETTE_ICON : DOG_SILHOUETTE_ICON;
          }

          return puppy ? PUPPY_SILHOUETTE : DOG_SILHOUETTE;
        })()}
      </div>
    </div>
  );
}

DogPlaceholderSvg.propTypes = {
  icon: PropTypes.bool,
  puppy: PropTypes.bool,
  rect: PropTypes.bool,
  className: PropTypes.string,
  minWidth: PropTypes.string,
  minHeight: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

DogPlaceholderSvg.defaultProps = {
  icon: false,
  puppy: false,
  rect: false,
  className: null,
  minWidth: null,
  minHeight: null,
  width: null,
  height: null
};
